import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { CreatePostcodePriceRequest, IPostcodeGroup, IPostcodeGroupsResponse, IPostcodePrice } from "../models/PostcodeGroup";
import { ISaveOnboardingCoverageRequest, ISaveOnboardingCoverageResponse } from "../models/Onboarding";
import { DefaultResponseWithData } from "../models/system";

export default function usePostcodePriceMutations() {
  const { get, post, put, patch, del } = useApiHelper();
  const queryClient = useQueryClient();


  const create = useMutation(
    (postcodePrice: CreatePostcodePriceRequest) => post("/postcodePrice", postcodePrice),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["postcodeGroups"]);
      },
    }
  );

  const createBulk = useMutation(
    (postcodePrices: any[]) => post("/postcodePrice/bulk", { items: postcodePrices }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["postcodeGroups"]);
      },
    }
  );

  const update = useMutation(
    (postcodePrice: IPostcodePrice) => patch(`/postcodePrice`, postcodePrice),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["postcodeGroups"]);
      },
    }
  );

  const remove = useMutation(
    (postcodeId: string) => del(`/postcodePrice/${postcodeId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["postcodeGroups"]);
      },
    }
  );

  /** Map picker: upsert districts as covered (active, priced) or excluded (inactive), creating groups per area. */
  const saveCoverage = useMutation(
    (body: ISaveOnboardingCoverageRequest) =>
      post<ISaveOnboardingCoverageRequest, DefaultResponseWithData<ISaveOnboardingCoverageResponse>>(
        "/postcodePrice/coverage",
        body
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["postcodeGroups"]);
      },
    }
  );

  return {
    // postcodeGroups,
    create,
    update,
    remove,

    createBulk,
    saveCoverage,
  };
}
